import { Outlet } from "react-router-dom";
import SidebarKegiatanku from "../sidebarKegiatanku/Sidebar";

const AppLayoutKegiatanku = () => {
    return <div style={{
        padding: '50px 0px 0px 370px'
    }}>
        <SidebarKegiatanku />
        <Outlet />
    </div>;
};

export default AppLayoutKegiatanku;